import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-monitor\"><g id=\"icon-monitor_Layer_2\" data-name=\"Layer 2\"><path d=\"M27.37,2.65H4.63A3.64,3.64,0,0,0,1,6.28V20.8a3.64,3.64,0,0,0,3.63,3.63H15v1.88l-3,0a1,1,0,0,0-1,1,1,1,0,0,0,1,1l8-.09a1,1,0,1,0,0-2l-3,0V24.43H27.37A3.64,3.64,0,0,0,31,20.8V6.28A3.64,3.64,0,0,0,27.37,2.65ZM29,20.8a1.63,1.63,0,0,1-1.63,1.63H4.63A1.63,1.63,0,0,1,3,20.8V6.28A1.63,1.63,0,0,1,4.63,4.65H27.37A1.63,1.63,0,0,1,29,6.28Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol